import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { auth } from "./firebase";
import i18n from "./i18n";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import "moment/min/locales.min";

Vue.use(VueMoment, {
  moment
});

Vue.config.productionTip = false;

Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("title", function(value) {
  if (!value) return "";
  return value.replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
});

Vue.filter("upper", function(value) {
  if (!value) return "";
  return value.toUpperCase();
});

let app;
auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,

      store,
      i18n,
      render: h => h(App)
    }).$mount("#app");
  }

  if (user) {
    console.log("dispatch from onAuthStateChanged");
    store.dispatch("fetchUserProfile", user);
  }
});
